import user from './user';
import menu from './menu';
import noti from './noti';
import promotion from './promotion';
import code from './code';
import client from './client';
import organ from './organ';
import content from './content';
import dashboard from './dashboard';
import log from './log';
import statistic from './statistic';
import systemresource from './systemresource';
import event from './event';
import help from './help';
import newsletter from './newsletter';
import jumin from './jumin';
import job from './job';
import wowservice from './wowservice';
import led from './led';

export default {
  user,
  menu,
  noti,
  promotion,
  code,
  client,
  organ,
  content,
  dashboard,
  log,
  statistic,
  systemresource,
  event,
  help,
  newsletter,
  jumin,
  job,
  wowservice,
  led,
};
